import { isMobile } from '@/modules/functions';
import Inputmask from 'inputmask';

export function phoneSelect() {
  const $phoneSelect = $('.form-control-select-phone');
  if (!$phoneSelect || $phoneSelect.length === 0) return;

  const $phoneEdit = $('.form-control-phone-edit');
  let country;
  if ($phoneEdit && $phoneEdit.length !== 0) {
    country = $phoneEdit.data('country');

    $.getJSON('/assets/json/phone-masks.json', (data) => {
      const item = data.find((x) => x.cc === country);
      new Inputmask(item.mask).mask($phoneEdit.get(0));
      $phoneEdit.attr('placeholder', item.mask);
    });
  }

  $.getJSON('/assets/json/phones.json', (data) => {
    $phoneSelect.select2({
      selectionCssClass: ':all:',
      dropdownCssClass: ':all:',
      data: data,
      placeholder: '',
      dropdownAutoWidth: true,
      escapeMarkup: function (markup) {
        return markup;
      },
    });

    if ($phoneEdit && $phoneEdit.length !== 0) {
      $phoneSelect.val(country);
      $phoneSelect.trigger('change');
    }
  });

  $phoneSelect.on('select2:open', (e) => {
    const width = $phoneSelect.parent().width();

    let size = 105;

    if (isMobile()) {
      size = 70;
    }

    $('.select2-dropdown.form-control-select-phone').css({
      marginLeft: -(width - size),
    });
  });

  $.getJSON('/assets/json/phone-masks.json', (data) => {
    let mask;
    const $phoneControl = $('.form-control-phone');
    $phoneControl.attr('type', 'text');

    mask = data.find((x) => x.cc === 'RU').mask;
    $phoneControl.val('').attr('placeholder', mask);
    new Inputmask({
      mask: mask,
    }).mask('.form-control-phone');

    $phoneSelect.on('change', (e) => {
      $phoneControl.attr('type', 'text');
      mask = data.find((x) => x.cc === $phoneSelect.val()).mask;
      $phoneControl.val('').attr('placeholder', mask);
      new Inputmask({
        mask: mask,
      }).mask('.form-control-phone');
    });

    const $hiddenText = $phoneControl.nextUntil('.form-field-hidden-text');

    if ($hiddenText && $hiddenText.length !== 0) {
      $phoneControl.on('blur', () => {
        let val = $phoneControl.val();
        val = val.replace(/_/g, '');
        if (mask && val.length === mask.length) {
          $phoneControl
            .addClass('show-hidden-text')
            .removeClass('error')
            .prev('.select2')
            .removeClass('error');
        } else {
          $phoneControl
            .removeClass('show-hidden-text')
            .addClass('error')
            .prev('.select2')
            .addClass('error');
        }
      });
    }
  });
}
